import { EventEmitter, Component, Input, Output } from '@angular/core';
import createDebug from 'debug';
import { MatButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { AdElDirective } from '../../directives/ad-el/ad-el.directive';

const Debug = createDebug('ConfirmationDialogComponent');

/**
 * Confirmation Dialog
 *
 * A simple Material dialog that displays a message with Cancel and Confirm buttons.
 * Used by the confirm directive to prompt the user before destructive actions.
 */

@Component({
  selector: 'confirmation-dialog-content',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [AdElDirective, MatButton, MatDialogActions, MatDialogContent],
})
export class ConfirmationDialogContentComponent {
  constructor(
    public dialog: MatDialogRef<ConfirmationDialogContentComponent>,
  ) {}

  /** Message - The confirmation message to display */ @Input()
  message!: string;

  /** Confirmed - Emitted when the user clicks Confirm */ @Output()
  confirmed: EventEmitter<any> = new EventEmitter<any>();

  /** Canceled - Emitted when the user clicks Cancel */ @Output()
  canceled: EventEmitter<any> = new EventEmitter<any>();

  /** Confirm Action */
  confirmAction(): void {
    // Tell the opener the user confirmed
    this.confirmed.emit();
  }

  /** Cancel Action */
  cancelAction(): void {
    // Tell the opener the user backed out
    this.canceled.emit();
  }
}
